import { SentResetPassword } from './SentResetPassword';
export default SentResetPassword;
